module.exports = __webpack_public_path__ + "static/img/pic_rjyf_cxnl_ydjr.4f76eec3.png";